import React from 'react';
import { motion } from 'framer-motion';
export function CtaSection() {
  return <section className="relative py-32 my-12 bg-eucalipto flex items-center justify-center px-6 text-center" data-id="element-26">
      {/* Top Wave */}
      <div className="wave-divider-top text-crema" data-id="element-27">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-28">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="currentColor" data-id="element-29"></path>
        </svg>
      </div>

      <motion.div className="relative z-10 max-w-3xl mx-auto space-y-8" initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-30">
        <h2 className="text-4xl md:text-5xl font-serif text-white leading-tight" data-id="element-31">
          ¿Listo para dar el primer paso?
        </h2>
        <p className="text-eucalipto-light text-lg md:text-xl font-light" data-id="element-32">
          Inicia tu camino hacia una vida más plena y consciente.
        </p>

        <div className="pt-4" data-id="element-33">
          <motion.a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="inline-block bg-terracota text-white px-8 py-4 rounded-full font-medium tracking-wide shadow-lg hover:bg-terracota-hover transition-colors duration-300" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-34">
            AGENDAR SESIÓN POR WHATSAPP
          </motion.a>
        </div>
      </motion.div>

      {/* Bottom Wave */}
      <div className="wave-divider-bottom text-crema" data-id="element-35">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-36">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="currentColor" data-id="element-37"></path>
        </svg>
      </div>
    </section>;
}